import API from '../../API/API'

/** Auth headers the entity endpoints expect. */
const authHeaders = () => ({
    authorization: `Bearer ${window.localStorage.getItem('accessToken')}`,
    'content-type': 'application/json'
})

const entitiesUrl = (connectorId, instancesId) =>
    `/Connection/${connectorId}/instance/${instancesId}/entities`

/**
 * The list endpoint returns one row per business entity with a flag and an
 * editable flag for each direction. Anything missing is treated as off and
 * locked, so an unexpected payload renders as read only rather than as a
 * toggle that silently fails to save.
 */
const toEntity = (entity) => ({
    id: entity.id,
    displayName: entity.displayName || entity.name || '',
    isInboundActive: Boolean(entity.isInboundActive),
    isOutboundActive: Boolean(entity.isOutboundActive),
    isInboundEditable: entity.isInboundEditable === true,
    isOutboundEditable: entity.isOutboundEditable === true
})

export const getEntities = (connectorId, instancesId) =>
    API.get(entitiesUrl(connectorId, instancesId), { headers: authHeaders() })
        .then((response) => (Array.isArray(response.data) ? response.data.map(toEntity) : []))

/**
 * Both directions go up on every save - the endpoint replaces the pair rather
 * than patching one flag - so callers pass the state the row should end in.
 * Responds with { result, message }: result false means the server accepted the
 * call but stored no change.
 */
export const saveEntityStatus = (connectorId, instancesId, entityId, status) =>
    API.post(
        `${entitiesUrl(connectorId, instancesId)}/${entityId}`,
        {
            isInboundActive: status.isInboundActive,
            isOutboundActive: status.isOutboundActive
        },
        { headers: authHeaders() }
    ).then((response) => response.data || {})
